export const SPECS = {
  CheckoutFromSDKInExpressCheckoutButtons: 'specs.stores.CheckoutFromSDKInExpressCheckoutButtons',
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems',
  SupportMemberOnlyCheckout: 'specs.stores.SupportMemberOnlyCheckout'
};
//# sourceMappingURL=SPECS.js.map